import qsharp from "refractor/qsharp";
export default qsharp;